module.exports = __webpack_public_path__ + "img/1.22be3c95.png";